import { Component, h, Prop } from '@stencil/core';
import { ButtonDisplay, ButtonSize, ButtonVariant, CssClassMap } from './jui-button.model';

@Component({
  tag: 'jui-button',
  styleUrl: 'jui-button.scss',
  shadow: true
})
export class JuiButton {
  /**
   * Button color: primary | secondary | success | info | warning | danger | low | high | subtle
   */
  @Prop() color: ButtonVariant = ButtonVariant.primary;

  /**
   * Button size: xs | sm | md | lg | xl
   */
  @Prop() size: ButtonSize = ButtonSize.md;

  /**
   * Button display: contained | ghost
   */
  @Prop() display: ButtonDisplay = ButtonDisplay.contained;

  /**
   * Button icon: a material icon name to use in the button: https://fonts.google.com/icons?selected=Material+Icons
   */
  @Prop() icon: string = null;

  /**
   * Button disabled flag
   */
  @Prop({ attribute: 'disabled', reflect: true })
  disabled: boolean;

  /**
   * Button title attribute
   */
  @Prop({ attribute: 'title', reflect: true })
  titleText = '';

  /**
   * Button loading: shows CSS loader
   */
  @Prop() loading: boolean;

  /**
   * Button expand: flex to full width of container
   */
  @Prop() expand = false;

  @Prop() type = 'button';

  @Prop()
  cursor?;

  @Prop() disableUserSelect = false;

  private getCssClassMap(): CssClassMap {
    return {
      [this.color]: true,
      ['expand']: this.expand,
      [this.size]: true,
      [this.display]: true,
      ['disableUserSelect']: this.disableUserSelect
    };
  }

  private getCursor() {
    if (this.loading) {
      return { cursor: 'progress' };
    }
    if (this.cursor) {
      return { cursor: this.cursor };
    }
    return null;
  }

  render() {
    const classMap = this.getCssClassMap();
    return (
      <button
        class={classMap}
        disabled={this.disabled}
        title={this.titleText}
        type={this.type}
        style={this.getCursor()}
      >
        <slot name="icon"></slot>
        <slot></slot>
        {this.loading ? <span class="loader"></span> : null}
      </button>
    );
  }
}
